import { Injectable } from '@angular/core';

declare const hj;

@Injectable({
  providedIn: 'root',
})
export class HotJarEventsService {
  constructor() {}

  triggerHotJarEvent(eventName) {
    try {
      hj('event', eventName);
    } catch (e) {}
  }
}
